export default __webpack_public_path__ + "static/media/icon-mag_glassicon.3d07c3cf.svg";